import { Settings } from "../../Settings"
import { GlobalState } from "../GlobalState"
import { RequestMaker, EnumRequestPrefix } from "./RequestMaker"
import { JsonUser } from "../json-data-types/JsonUser"
import { GlobalUser } from "../GlobalUser"

const filename = 'ServerUsers.ts'

export module ServerUsers{
    

    export async function loginAsync(email:string, password:string):Promise<string>{
        const method = 'loginAsync'
        if(!email || email.length<2) {
            const errorMessage = 'email is too short, ignoring request'
            console.warn(filename, method, errorMessage, email)
            return errorMessage
        }
        if(!password || password.length<Settings.minUserPasswordLength) {
            const errorMessage = 'password is too short, ignoring request'
            console.warn(filename, method, errorMessage, password)
            return errorMessage
        }
        email = email.toLowerCase()
        //const data = await RequestMaker.postJsonAsync('/login', {email, password}, EnumRequestPrefix.Websocket)
        //console.log('data=', data)
        //return false
        try {
            const data = await RequestMaker.sendWebsocketJsonRequestAsync<{sessionId:string, user:Partial<JsonUser>}>({query:'user-login', params:{email, password}}, filename)
            // receiving:
            // {success:true, sessionId:'...', user:{...}}
            // console.log(filename, 'loginAsync', 'response=', data)
            
            if(data){
                //if(Settings.keepSessionInLocalStorage){
                    // console.log(filename, method, 'saving sessionId to localStorage for dev only')
                    if(!data.sessionId){
                        console.error('no sessionId in response from server')
                    }
                    GlobalUser.sessionIdO.set(data.sessionId)
                    // console.log('setting sessionId to localStorage', localStorage.getItem(Settings.localStorageKey_SessionId))
                //}

                
                GlobalUser.loggedInUserO.set(data.user)
                // console.log('setting loggedIn User', GlobalUser.loggedInUserO.get())
                return ''
            }
        } catch(x){
            console.error(filename, method, 'loginAsync error', x)
            return ''+x
        }

        return 'unknown error'
        
        // return false
    }

    // export async function resetPasswordAsync(email:string, inn:string, phone:string){
    //     const method = 'resetPasswordAsync'
    //     if(!email || email.length<2){
    //         console.warn(filename, method, 'email is too short, ignoring request', email)
    //         return false
    //     }
    //     if(!inn || inn.length<5){
    //         console.warn(filename, method, 'inn is too short, ignoring request', inn)
    //         return false
    //     }

    //     if(!phone || phone.length<5){
    //         console.warn(filename, method, 'phone is too short, ignoring request', phone)
    //         return false
    //     }
    //     email = email.toLocaleLowerCase()
    // }


    export async function logoutAsync(who:string){
        //console.log('logoutAsync', who)
        //const response = await RequestMaker.postJsonAsync('/logout', {}, EnumRequestPrefix.Websocket)
        const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'user-logout'}, filename+':'+who)
        //console.log('logout response=', response)
        // console.log(filename, 'logout response', response)
        GlobalUser.loggedInUserO.set(undefined)
        GlobalUser.sessionIdO.set(undefined)
        localStorage.removeItem(Settings.localStorageKey_SessionId)
    }
    
    export async function getCurrentJsonUserAsync():Promise<JsonUser>{
        //const response = await RequestMaker.sendWebsocketRouteRequestAsync('/user-get', filename)
        const response = await RequestMaker.sendWebsocketJsonRequestAsync({query:'user-get'}, filename)
        return response as JsonUser
    }


}